// extracted by mini-css-extract-plugin
export default {"description":"modal-confirm_description__5U9wq","buttons":"modal-confirm_buttons__5s1t+"};